import { render } from "./LabelsFooterCounter.vue?vue&type=template&id=29426a39&scoped=true"
import script from "./LabelsFooterCounter.vue?vue&type=script&lang=js"
export * from "./LabelsFooterCounter.vue?vue&type=script&lang=js"

import "./LabelsFooterCounter.vue?vue&type=style&index=0&id=29426a39&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29426a39"]])

export default __exports__